import React from 'react';
import { type Question } from '../../content/types';
import { VisualAidFactory } from '../../visuals';
import { LatexRenderer } from '../../components/ui/LatexRenderer';
/**
 * Id van het element met de vraagtekst. De antwoordgroep verwijst hiernaar met
 * `aria-labelledby`, zodat een schermlezer de vraag noemt bij het betreden van
 * de opties. Er staat altijd precies één vraag tegelijk op het scherm, dus een
 * vaste id is hier veilig en voorkomt dat de id door twee componenten heen
 * doorgegeven moet worden.
 */
export const ASSESSMENT_QUESTION_TEXT_ID = 'assessment-question-text';
interface AssessmentQuestionCardProps {
  question: Question;
  children: React.ReactNode;
}
export function AssessmentQuestionCard({
  question,
  children
}: AssessmentQuestionCardProps) {
  const stimulusVisuals = question.stimulusAids ?? [];
  // Vaste id zodat de antwoordgroep zich aan de vraagtekst kan koppelen. De
  // vraag en de opties waren twee losse blokken zonder enige relatie: een
  // schermlezer las vier knoppen voor zonder te vertellen bij welke vraag ze
  // horen. Zie ASSESSMENT_QUESTION_ID in AssessmentMCOptions.
  return <div className="w-full max-w-3xl mx-auto" data-id="element-859" data-mp="35kaaax7r6rtf">
      <div className="bg-white rounded-2xl md:rounded-3xl shadow-lg overflow-hidden relative" data-id="element-860" data-mp="2rtnbl51zt1xc">
        {/* Assessment Accent Strip */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-indigo-500 via-indigo-400 to-indigo-500" aria-hidden="true" data-id="element-861" data-mp="2wr72b4fvn766" />
        

        {/* Question Text */}
        <div className="p-6 sm:p-8 md:p-10 border-b border-slate-100 bg-white pt-8 sm:pt-10" data-id="element-862" data-mp="2muki8hvdkk57">
          <div id={ASSESSMENT_QUESTION_TEXT_ID} className="text-fluid-xl md:text-fluid-2xl font-bold text-slate-800 leading-relaxed whitespace-pre-line tracking-tight" data-id="element-863" data-mp="28vb4doun624e">
            
            <LatexRenderer content={question.question} data-id="element-864" data-mp="73fxdmjbylsi" />
          </div>
        </div>

        {/* Stimulus Aids Zone */}
        {stimulusVisuals.length > 0 && <div className="p-6 sm:p-8 bg-slate-50/80 border-b border-slate-100 space-y-6" data-id="element-865" data-mp="c1hq6z6k5zh6">
            {stimulusVisuals.map((aid, index) => <VisualAidFactory key={index} visualAid={aid} isCorrect={undefined} mode="stimulus" data-id="element-866" data-mp="9l9mvr1eak0r" data-mpi={index} />)}
          </div>}

        {/* Answer Area */}
        <div className="p-6 sm:p-8 bg-slate-50/50" data-id="element-867" data-mp="nz8hwta6erm">{children}</div>
      </div>
    </div>;
}